import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Drawer from './components/Drawer';
import HomePage from './pages/HomePage';
import VotersPage from './pages/VotersPage';
import AboutPage from './pages/AboutPage';
import MailingListsPage from './pages/MailingListsPage';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import UserProfilePage from './pages/UserProfilePage';
import PostcardsPage from './pages/PostcardsPage';
import Footer from './components/Footer';
import { AuthProvider } from './contexts/AuthContext';
import { CountiesProvider } from './contexts/CountiesContext';

function AppContent() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();

  // Toggle drawer state
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  // Close drawer
  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  // Get active page from current location
  const getActivePage = (pathname) => {
    switch (pathname) {
      case '/':
        return 'mainContent';
      case '/voters':
        return 'voterContent';
      case '/about':
        return 'aboutContent';
      case '/mailing-lists':
        return 'mailingListsContent';
      case '/login':
        return 'loginContent';
      case '/signup':
        return 'signupContent';
      case '/profile':
        return 'profileContent';
      case '/postcards':
        return 'postcardsContent';
      default:
        return 'mainContent';
    }
  };

  const activePage = getActivePage(location.pathname);

  return (
    <div className="App">
      <Drawer
        isOpen={isDrawerOpen}
        onClose={closeDrawer}
        activePage={activePage}
      />

      <Header
        toggleDrawer={toggleDrawer}
        activePage={activePage}
        isDrawerOpen={isDrawerOpen}
      />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/voters" element={<VotersPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/mailing-lists" element={<MailingListsPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/profile" element={<UserProfilePage />} />
        <Route path="/postcards" element={<PostcardsPage />} />
      </Routes>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CountiesProvider>
        <Router>
          <AppContent />
        </Router>
      </CountiesProvider>
    </AuthProvider>
  );
}

export default App;
